import type { ICardPaymentMethod } from "../interfaces/payment-method";

export type CardFundingKind = "DEBIT_CARD" | "CREDIT_CARD";

export type UnavailableCardReason =
  | "creditOnDebitRoute"
  | "debitOnCreditRoute"
  | "unclassified"
  | "generic";

/** Catalog class only when CVS mapped one. Prepaid / unknown stay null. */
export const cardFundingKind = (
  card: Pick<ICardPaymentMethod, "fundingMethod">
): CardFundingKind | null =>
  card.fundingMethod === "CREDIT_CARD" || card.fundingMethod === "DEBIT_CARD"
    ? card.fundingMethod
    : null;

export const isCardFundingAvailable = (
  card: Pick<ICardPaymentMethod, "fundingMethod">,
  available: readonly string[]
): boolean => {
  const kind = cardFundingKind(card);
  return kind != null && available.includes(kind);
};

export const unavailableCardReason = (
  card: Pick<ICardPaymentMethod, "fundingMethod">,
  available: readonly string[]
): UnavailableCardReason => {
  const kind = cardFundingKind(card);
  if (kind == null) return "unclassified";
  const hasDebit = available.includes("DEBIT_CARD");
  const hasCredit = available.includes("CREDIT_CARD");
  if (kind === "CREDIT_CARD" && hasDebit && !hasCredit) {
    return "creditOnDebitRoute";
  }
  if (kind === "DEBIT_CARD" && hasCredit && !hasDebit) {
    return "debitOnCreditRoute";
  }
  return "generic";
};
